import React from 'react'

import PropTypes from 'prop-types'
import { Modal } from 'Components/atoms'
import { ReactComponent as NotMinIcon } from 'Assets/Icons/not-min.svg'

import { TitleME, Message } from './styled'

const ModalExtraServiceError = ({ showModal, setShowModal, message, color, title, width, height }) => (
  <Modal
    isOpen={showModal}
    setIsOpen={setShowModal}
    width={width}
    height={height}
    align='center'
    marginTop='2rem'
    borderRadius='0.5rem'
  >
    <NotMinIcon width={40} height={40} />
    <>
      <TitleME color={color}>{title}</TitleME>
      <Message>{message}</Message>
    </>
  </Modal>
)

ModalExtraServiceError.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,

  message: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

ModalExtraServiceError.defaultProps = {
  showModal: false,
  setShowModal: () => {},

  message: '',
  color: '',
  title: '',
  width: '',
  height: '',
}

export default ModalExtraServiceError
